var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 4.86903H10.0378L8.55281 3.38465C7.705 2.53621 6.36094 2.46309 5.42531 3.20903L2.05063 5.90903C1.94 5.9984 1.875 6.13278 1.875 6.27528V11.9003C1.875 12.0903 1.98938 12.2615 2.16531 12.3337L2.32812 12.4006C3.82062 13.0015 5.40344 13.3065 7.03125 13.3065H8.90625C9.68156 13.3065 10.3125 12.6756 10.3125 11.9003C10.3125 11.7178 10.2778 11.5428 10.2137 11.3822C10.8106 11.2197 11.25 10.6725 11.25 10.0253C11.25 9.84278 11.2153 9.66778 11.1512 9.50715C11.4166 9.43496 11.6506 9.28684 11.8284 9.08778C12.0519 8.83871 12.1875 8.50996 12.1875 8.15028C12.1875 7.9859 12.1591 7.82809 12.1069 7.68153H14.5938C15.3691 7.68153 16 7.05059 16 6.27528C16 5.49996 15.3691 4.86903 14.5938 4.86903Z",
    fill: "#FEC478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1512 9.50531C11.2153 9.66594 11.25 9.84094 11.25 10.0234C11.25 10.6706 10.8106 11.2178 10.2137 11.3803C10.2778 11.5409 10.3125 11.7159 10.3125 11.8984C10.3125 12.6737 9.68156 13.3047 8.90625 13.3047H7.03125C5.40344 13.3047 3.82062 12.9997 2.32812 12.3988L2.16531 12.3319C1.98938 12.2597 1.875 12.0884 1.875 11.8984V9.08594H11.8284C11.6506 9.28503 11.4166 9.43313 11.1512 9.50531Z",
    fill: "#FEB756"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 13.3047H0.46875C0.209656 13.3047 0 13.095 0 12.8359V5.33594C0 5.07684 0.209656 4.86719 0.46875 4.86719H1.40625C2.18169 4.86719 2.8125 5.498 2.8125 6.27344V11.8984C2.8125 12.6739 2.18169 13.3047 1.40625 13.3047Z",
    fill: "#FD003A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.08594V12.8359C0 13.095 0.209656 13.3047 0.46875 13.3047H1.40625C2.18169 13.3047 2.8125 12.6739 2.8125 11.8984V9.08594H0Z",
    fill: "#E50027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerIcon);
export default __webpack_public_path__ + "static/media/finger_icon.ecacaa4dbb1123a935211cc01554e8d5.svg";
export { ForwardRef as ReactComponent };